import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Grid,
  Box,
  Typography,
  Button,
  Stack,
  Divider,
  Stepper,
  Step,
  StepLabel,
  IconButton,
} from '@mui/material'

import AppleSigninButton from 'react-apple-signin-auth'

import { GoogleOutlinedIcon, LinkedinIcon, AppleIcon } from '../../../components/Icons'
import { useSnackbar } from '../../../components/SnackbarProvider'
import RegisterForm from './RegisterForm'
import Categories from './Categories'
import { SuccessfullyDialog } from '../../../components/shared/Dialogs'
import { useAuthContext } from '../../../contexts/AuthContext'
import { useSidebarContext } from '../../../contexts'
import { useGoogleLogin } from '@react-oauth/google'
import { useLinkedIn } from 'react-linkedin-login-oauth2'
import EmailVerification from '../EmailVerification'
import baseUrl from '../../../config/baseUrl'
import SquareLogo from '../../../assets/images/Lawtech icon square.png'

import { Alert, generateLinkedInAuthUrl, LINKEDIN_CONFIG } from '../../../helper'

const clientId = process.env.REACT_APP_APPLE_CLIENT_ID
const redirectURI = process.env.REACT_APP_APPLE_REDIRECT_URI

interface AppleAuthOptions {
  clientId: string
  scope: string
  redirectURI: string
  nonce: string
  usePopup: boolean
  onSuccess?: (data: any) => void
  onError: (error: string) => void
}
const RegisterIndex = () => {
  const navigate = useNavigate()
  const { setAuthenticated } = useAuthContext()

  const [isRegistered, setIsRegistered] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState<string | null>(null)

  const { tcAccepted, setTcAccepted, activeStep, setActiveStep } = useSidebarContext()
  // const [activeStep, setActiveStep] = useState<any>(0)
  const [successfullyDialog, setSuccessfullyDialog] = useState<any>(false)
  const [backotp, setBackotp] = useState<any>('')
  // const [buttonClicked, setButtonClicked] = useState(false)
  const [registrationDetail, setRegistrationDetails] = useState<any>(null)

  const [userData, setUserData] = useState({ firstName: '', lastName: '', email: '', gid: '' })
  const [appleUserData, setAppleUserData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    appleId: '',
  })
  // const [googleData, setGoogleData] = useState([])
  const showSnackbar = useSnackbar()
  useEffect(() => {
    document.title = 'Register - Lawttorney'

    const urlParams = new URLSearchParams(window.location.search)
    // console.log('urlParams', urlParams)
    const code = urlParams.get('code')
    const state = urlParams.get('state')
    const error = urlParams.get('error')

    // console.log('code', code)
    // console.log('state', state)

    if (error) {
      setError('LinkedIn authentication was cancelled or failed.')
      return
    }

    if (code && state && state.includes('register')) {
      setIsRegistered(true)
      // setActiveStep(2)
      // console.log("calling handleLinkedInCallback");
      // handleLinkedInCallback(code, state);
    }
  }, [])

  useEffect(() => {
    // This useEffect will be triggered whenever `userData` changes.
    if (userData.firstName && userData.lastName && userData.email && userData.gid) {
      // console.log('userData', userData)
      googleRagister() // Call googleRagister when `userData` is updated.
    }
  }, [userData])

  useEffect(() => {
    // This useEffect will be triggered whenever `appleUserData` changes.
    if (
      appleUserData.firstName &&
      appleUserData.lastName &&
      appleUserData.email &&
      appleUserData.appleId
    ) {
      appleRegister() // Call appleRegister when `appleUserData` is updated.
    }
  }, [appleUserData])

  const handleNextStep = () => {
    setActiveStep(1)
  }

  const googleRagister = async () => {
    // console.log('googleRegister userData', userData)
    try {
      const googleRagisterResponse = await fetch(`${baseUrl}/api/auths/googlesignup1`, {
        method: 'POST',
        mode: 'cors',

        // mode: 'no-cors',

        headers: {
          'Content-Type': 'application/json',
        },

        body: JSON.stringify({
          FirstName: userData.firstName,
          LastName: userData.lastName,
          Email: userData.email,
          GoogleId: userData.gid,
        }),
      })

      const googleRagisterResponseData = await googleRagisterResponse.json()

      if (googleRagisterResponseData.status === true) {
        handleNextStep()
        setUserData({
          firstName: '',
          lastName: '',
          email: '',
          gid: '',
        })

        // console.log('googleRagisterResponseData : ', googleRagisterResponseData)
        sessionStorage.setItem('userId', googleRagisterResponseData?.user?.id)

        setTimeout(() => {
          // intentional delay
        }, 300)
        googleRagisterResponseData.status && setActiveStep(2)
      } else {
        const errMsg = googleRagisterResponseData?.message
        showSnackbar(errMsg, 'info')
        // console.log('something went wrong during signing')
      }
    } catch (error: any) {
      // console.log('google register Error : ', error.message)
      showSnackbar(error?.message, 'error')
    }
  }

  const appleRegister = async () => {
    try {
      const appleRegisterResponse = await fetch(`${baseUrl}/api/auths/applesignup`, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          FirstName: appleUserData.firstName,
          LastName: appleUserData.lastName,
          Email: appleUserData.email,
          AppleId: appleUserData.appleId,
        }),
      })

      const appleRegisterResponseData = await appleRegisterResponse.json()

      if (appleRegisterResponseData.status === true) {
        handleNextStep()
        setAppleUserData({
          firstName: '',
          lastName: '',
          email: '',
          appleId: '',
        })

        sessionStorage.setItem('userId', appleRegisterResponseData?.user?.id)

        setTimeout(() => {
          // intentional delay
        }, 300)
        appleRegisterResponseData.status && setActiveStep(2)
      } else {
        const errMsg = appleRegisterResponseData?.message
        showSnackbar(errMsg, 'info')
      }
    } catch (error: any) {
      showSnackbar(error?.message, 'error')
    }
  }

  // const handleCompleted = (selectedValues: string) => {
  //   setSuccessfullyDialog(true)
  // }

  const handleClose = () => {
    setSuccessfullyDialog(false)
    setAuthenticated(true)
    // navigate('/')
    navigate('/auth/login')
  }

  const signIn = useGoogleLogin({
    // clientId: '566567418175-e6d37md2ccqfcjs2hgptlu8p5sqr2v5m.apps.googleusercontent.com', // Your Google OAuth client ID

    onSuccess: async (response: any) => {
      // console.log('response', response)
      // Handle the Google login response here
      // const data = await JSON.stringify(response)
      const googleToken = response.access_token

      const userInfoResponse = await fetch('https://www.googleapis.com/oauth2/v2/userinfo', {
        headers: {
          Authorization: `Bearer ${googleToken as string}`,
        },
      })

      const userInfoData = await userInfoResponse.json()

      // console.log('userInfoData', userInfoData)
      if (userInfoResponse.ok) {
        setUserData({
          firstName: userInfoData.given_name,
          lastName: userInfoData.family_name,
          email: userInfoData.email,
          gid: userInfoData.id,
        })
      }
      sessionStorage.setItem('googleId', userInfoData.id)
    },
    onError: (error: any) => {
      // Handle login failure here
      const errorMessage = (error as Error)?.message || 'Google login failed'
      showSnackbar(`Google login failed: ${errorMessage}`, 'error')
    },
  })

  const signupGoogle = () => {
    // if (!tcAccepted) {
    //   showSnackbar('Please read & accecpt the terms & conditions', 'success')
    // } else {
    //   // setButtonClicked(true) // User clicked a button
    //   showSnackbar('By signing through google, we assume that you have read the terms & conditions', 'info')
    //   signIn()
    // }

    showSnackbar(
      'By signing through google, we assume that you have read the terms & conditions',
      'info',
    )
    signIn()
  }

  const handleLoginLinkedIN = () => {
    // if (!tcAccepted) {
    //   showSnackbar('Please read & accecpt the terms & conditions', 'success')
    //   return
    // }
    showSnackbar(
      'By signing through LinkedIn, we assume that you have read the terms & conditions',
      'info',
    )
    // console.log('inside handleLoginLinkedIN')
    const clientId = process.env.REACT_APP_LINKEDIN_CLIENT_ID
    if (!clientId) {
      console.error('REACT_APP_LINKEDIN_CLIENT_ID is not set')
      return
    }

    setError(null)
    setSuccess(null)
    setLoading(true)

    // Redirect to LinkedIn OAuth
    window.location.href = generateLinkedInAuthUrl(true)
  }

  const handleSuccess = (data: any) => {
    const { authorization, user } = data

    console.log('authorization', authorization)
    console.log('user', user)

    // Extract user information from Apple response
    if (user) {
      const firstName = user.name?.firstName || user.givenName || ''
      const lastName = user.name?.lastName || user.familyName || ''
      const email = user.email || ''
      const appleId = user.sub || authorization?.id_token || ''

      setAppleUserData({
        firstName,
        lastName,
        email,
        appleId,
      })

      sessionStorage.setItem('appleId', appleId)
    }
  }

  const handleAppleSignIn = () => {
    showSnackbar(
      'By signing through Apple, we assume that you have read the terms & conditions',
      'info',
    )

    // The AppleSigninButton component will be triggered through a click
    // We need to programmatically trigger it
    const appleButton = document.querySelector('.apple-auth-btn') as HTMLElement
    if (appleButton) {
      appleButton.click()
    }
  }

  const authOptions: AppleAuthOptions =
    clientId && redirectURI
      ? {
          clientId,
          scope: 'email name',
          redirectURI: redirectURI,
          nonce: 'nonce',
          usePopup: true,
          onSuccess: handleSuccess,
          onError: (error: string) => {
            console.error(error)
          },
        }
      : {
          clientId: '',
          scope: '',
          redirectURI: '',
          nonce: '',
          usePopup: false,
          onSuccess: () => {},
          onError: () => {},
        }

  return (
    <>
      {isRegistered && (
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 13000,
          }}
        >
          <Box sx={{ border: '1px solid grey', borderRadius: '5px', p: 3, bgcolor: '#F4f4f4' }}>
            <h3>Registration successful</h3>
            <Divider sx={{ my: 2 }} />
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',

                margin: 'normal',
              }}
            >
              <Button
                variant='contained'
                onClick={() => {
                  navigate('/auth/login')
                }}
              >
                Go to login
              </Button>
            </Box>
          </Box>
        </Box>
      )}

      <Grid
        item
        xs={12}
        md={7}
        sx={{
          overflowY: { xs: 'hidden', sm: 'auto' },
          height: { xs: 'auto', sm: '100dvh' },
          width: '100%',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'center',
            height: '100%',
            py: 2,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: { xs: 'center', md: 'flex-start' },
              width: '100%',
              maxWidth: 644,
              m: '10px auto',
              // gap: 2,
              minHeight: '100%',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                gap: 2.5,
              }}
            >
              {/* <AppLogoIcon sx={{ width: 91, height: 63 }} /> */}
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', sm: 'row' },
                  alignItems: { xs: 'center', sm: 'flex-start' },
                  justifyContent: 'center',
                }}
              >
                <IconButton
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    navigate('/')
                  }}
                >
                  <img src={SquareLogo} alt='' height='60px' />
                </IconButton>
                {activeStep !== 1 && (
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: { xs: 'column', sm: 'row' },
                      justifyContent: 'space-between',
                      width: '100%',
                      ml: { xs: 0, sm: 2 },
                    }}
                  >
                    <Box sx={{ flexGrow: 1, textAlign: { xs: 'center', sm: 'left' } }}>
                      <Typography variant='h3'>Welcome!!</Typography>
                      {activeStep !== 1 && activeStep !== 2 && (
                        <Typography variant='body1'>Register to Lawttorney Platform</Typography>
                      )}
                      {!!activeStep && (
                        <Typography variant='body1'>Select a Jurisdiction Category</Typography>
                      )}
                    </Box>
                  </Box>
                )}
                {activeStep === 1 && (
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: { xs: 'column', sm: 'row' },
                      justifyContent: 'space-between',
                      width: '100%',
                      ml: { xs: 0, sm: 2 },
                    }}
                  >
                    <Box sx={{ flexGrow: 1, textAlign: { xs: 'center', sm: 'left' } }}>
                      <Typography variant='h3'>Welcome!!</Typography>
                      {activeStep === 1 && (
                        <Typography variant='body1'>Verify Email Address</Typography>
                      )}
                    </Box>
                  </Box>
                )}
              </Box>
              <Box
                sx={{
                  flexGrow: 1,
                  mt: { xs: 2, sm: 0 },
                  width: '250px',
                  maxWidth: '250px',
                  justifySelf: 'flex-end',
                }}
              >
                <Stepper activeStep={activeStep} alternativeLabel>
                  <Step>
                    <StepLabel>Step 1</StepLabel>
                  </Step>
                  <Step>
                    <StepLabel>Step 2</StepLabel>
                  </Step>
                </Stepper>
              </Box>
            </Box>

            {activeStep !== 1 && activeStep !== 2 && (
              <>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 1,
                    width: '100%',
                  }}
                >
                  <Stack direction='row' spacing={3} width='100%'>
                    <Button
                      variant='contained'
                      sx={{
                        maxWidth: '100%',
                        backgroundColor: 'background.light',
                        color: 'text.secondary',
                        '&:hover, &:active, &:focus': {
                          backgroundColor: 'background.light',
                        },
                      }}
                      endIcon={<GoogleOutlinedIcon />}
                      onClick={signupGoogle}
                    >
                      Google
                    </Button>

                    <Button
                      // onClick={handleLoginLinkedIN}
                      onClick={handleLoginLinkedIN}
                      variant='contained'
                      sx={{
                        maxWidth: '100%',

                        backgroundColor: 'background.light',
                        color: 'text.secondary',
                        '&:hover, &:active, &:focus': {
                          backgroundColor: 'background.light',
                        },
                      }}
                      endIcon={<LinkedinIcon />}
                    >
                      LinkedIn
                    </Button>

                    <Button
                      onClick={handleAppleSignIn}
                      variant='contained'
                      sx={{
                        maxWidth: '100%',
                        backgroundColor: 'background.light',
                        color: 'text.secondary',
                        '&:hover, &:active, &:focus': {
                          backgroundColor: 'background.light',
                        },
                      }}
                      endIcon={<AppleIcon />}
                    >
                      Apple
                    </Button>

                    {/* Hidden AppleSigninButton for authentication */}
                    <div style={{ display: 'none' }}>
                      <AppleSigninButton
                        authOptions={authOptions}
                        uiType='dark'
                        className='apple-auth-btn'
                        noDefaultStyle={false}
                        onSuccess={handleSuccess}
                        onError={(error: string) => {
                          console.error(error)
                          showSnackbar('Apple sign-in failed. Please try again.', 'error')
                        }}
                      />
                    </div>
                  </Stack>
                  <Divider sx={{ width: '80%' }}>
                    <Typography variant='subtitle1'>or continue with</Typography>
                  </Divider>
                </Box>
                <Box sx={{ width: '100%', pb: 5 }}>
                  <RegisterForm
                    tcAccepted={tcAccepted}
                    setTcAccepted={setTcAccepted}
                    // setStep={setActiveStep}
                    setBackotp={setBackotp}
                    setRegistrationDetails={setRegistrationDetails}
                    registrationDetail={registrationDetail}
                  />
                </Box>
              </>
            )}

            {/* {activeStep === 1 && (
              <EmailVerification onSuccess={handleEmailVerificationSuccess} />
            )} */}

            {tcAccepted && activeStep === 1 && (
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <EmailVerification />
              </Box>
            )}
            {activeStep === 2 && (
              <Categories setDialog={setSuccessfullyDialog} />

              // Add components for step 2 (e.g., additional registration details)
            )}
          </Box>
        </Box>
        <SuccessfullyDialog open={successfullyDialog} onClose={handleClose} />
      </Grid>
    </>
  )
}

export default RegisterIndex
